// model / family / team classification.
// ported from worker.js:41 (teamOf), worker.js:216-217 (MODEL_ORDER, modelKey),
// renderer.js:6696-6697 (families, REPORT_KEY_TEAM).
export const FAMILIES = ['40-50', 'GT7-GTX-38', '45-47-XPD'];
export const TEAMS = ['GGO', 'ALPHAS', 'XPD'];
/** the 9 model buckets shown on the ProductionReporting MAIN sheet (order matters). */
export const MODEL_ORDER = ['GT7', 'GT9', 'GTX', '38', '40', '45', '47', '50', 'XPD'];
const LEADING_MODEL = new RegExp(`^(${MODEL_ORDER.join('|')})(?:\\s*[-–·:]\\s*|\\s+)(\\S.*)$`, 'i');
/** A production boat title as model and name. The sheet writes "GT7_FANDY"; a title typed without the
 *  underscore ("GT7 FANDY", "GT7 - FANDY") still counts as that model when it starts with a known one,
 *  so the boat isn't left out of its model. */
export function splitBoatTitle(raw) {
    const t = (raw ?? '').trim();
    const us = t.indexOf('_');
    if (us >= 0)
        return { model: t.slice(0, us).trim(), name: t.slice(us + 1).trim() };
    const m = LEADING_MODEL.exec(t);
    if (m)
        return { model: m[1].toUpperCase(), name: m[2].trim() };
    return { model: '', name: t };
}
/** A reserved slot or placeholder boat, not a real one: the name (after the model) is "SLOT…" ("40_SLOT 12",
 *  "GT7 SLOT-2", "SLOT"), "TBD" / "TBA" / "Reserved", or just a number ("GT7_3", "40_#2").
 *  Not "40_SLOTHER" or any real name. */
export function isSlotBoat(title) {
    const n = splitBoatTitle(title).name.trim();
    return /^slot(?![a-z])/i.test(n) || /^(?:tbd|tba|reserved)$/i.test(n) || /^#?\d{1,2}$/.test(n) || /^-+$/.test(n);
}
/** Human-friendly team name = the models each team builds (shown instead of the internal code). */
export const TEAM_LABEL = {
    GGO: 'GT7, GT9, GTX, 38, 45, 47',
    ALPHAS: '40, 50',
    XPD: 'XPD',
};
export const teamLabel = (t) => TEAM_LABEL[t] ?? t;
/** map a raw model string to a production team. ported from worker.js:41. */
export function teamOf(model) {
    const s = String(model ?? '').toUpperCase().trim();
    if (s.includes('XPD'))
        return 'XPD';
    if (s === '40' || s === '50' || s.includes('ALPHA'))
        return 'ALPHAS';
    return 'GGO';
}
/** normalize a model prefix to one of MODEL_ORDER (or the raw uppercase). worker.js:217. */
export function modelKey(prefix) {
    const s = String(prefix ?? '').trim().toUpperCase();
    if (MODEL_ORDER.includes(s))
        return s;
    if (s.includes('XPD'))
        return 'XPD';
    if (/GT7/.test(s))
        return 'GT7';
    if (/GT9/.test(s))
        return 'GT9';
    if (/GTX/.test(s))
        return 'GTX';
    if (/47|OMEGA/.test(s))
        return '47';
    if (/45/.test(s))
        return '45';
    if (/38/.test(s))
        return '38';
    if (/50/.test(s))
        return '50';
    if (/40/.test(s))
        return '40';
    return s || '?';
}
//# sourceMappingURL=model.js.map